/* eslint-disable no-nested-ternary */
/* eslint-disable no-unused-vars */
/* eslint-disable no-param-reassign */
/* eslint-disable guard-for-in */
/* eslint-disable no-restricted-syntax */
/* eslint-disable consistent-return */
/* eslint-disable react/prop-types */
/* eslint-disable no-console */
/* eslint-disable prefer-const */
/* eslint-disable react/button-has-type */
/* eslint-disable react/self-closing-comp */
/* eslint-disable new-cap */
/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable no-await-in-loop */
/* eslint-disable max-len */
/* eslint-disable react/forbid-prop-types */
/* eslint-disable no-underscore-dangle */
import React, { useState, useEffect, useRef } from 'react';
import { Redirect, useLocation } from 'react-router-dom';
import { Row, Col, Container } from 'reactstrap';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import {
  Button,
  Grid,
  IconButton,
} from '@material-ui/core';
import { Search } from '@material-ui/icons';
import '../../shared/arial';
import Loader from 'react-loader-spinner';
import MaterialTable from 'material-table';
import { makeStyles } from '@material-ui/core/styles';
import { saveAs } from 'file-saver';
import { Loading, createXlsx, exportXlsx } from '../../helpers/utils';
import examType1Services from '../../redux/services/examType1Services';
import ExamResultsDetails from './ExamResultsDetails';
import 'jspdf-autotable';
import DownloadQuizsDetails from './DownloadQuizsDetails';
import DownloadQuizCorrection from './DownloadQuizCorrection';

const zip = require('jszip')();
const JsPDF = typeof window !== 'undefined' ? require('jspdf').jsPDF : null;

const useStyles = makeStyles(() => ({
  root: {
    width: '100%',
    marginBottom: 20,
  },
  resultRow: {
    width: '100%',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    marginTop: '10px',
  },
  gradeDetails: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    width: '100%',
  },
  totalGrade: {
    // color: '#000000',
    fontSize: '13px',
    fontWeight: 'bold',
  },
  resultDetail: {
    // color: '#666666',
    fontSize: '13px',
  },
}));

const ExamResultsType1 = ({
  grpLvl1,
  grpLvl2,
  semester,
  examIdentifier,
}) => {
  const [loadingState, setLoadingState] = useState(false);
  const [substring, setSubstring] = useState(null);
  const [open, setOpen] = useState(false);
  const [redirect, setRedirect] = useState(false);
  const [group, setGroup] = useState({});
  const [exam, setExam] = useState({});
  const [examId, setExamId] = useState();
  const [totalPapers, setTotalPapers] = useState(0);
  const refTable = useRef();

  const [examData, setExamData] = useState([]);

  const classes = useStyles();

  const columns = [
    {
      title: 'Action',
      field: '',
      render: (rowData) => (
        <Search
          onClick={() => {
            setExamId(rowData.testId);
            setOpen(true);
          }}
        />
      ),
    },
    {
      title: 'Firstname',
      field: 'firstname',
    },
    {
      title: 'Name',
      field: 'name',
      defaultSort: 'asc',
    },
    {
      title: 'Note',
      field: 'note',
      render: (rowData) => `${rowData.note} / ${examIdentifier === '6818b5f7e1af81f95768bbc5'
        ? 60
        : examIdentifier === '62d509e1c5943a200c119a04'
          ? 40
          : 100}`,
    },
    {
      title: 'Total registered',
      field: 'note',
      render: (rowData) => `${rowData.total}`,
    },
    {
      title: 'Success',
      field: 'state',
    },
    {
      title: 'Problem',
      field: 'fetched',
    },
  ];

  const loadExamResults = async () => {
    const formatedArray = [];
    let papers = 0;
    setLoadingState(true);
    if (grpLvl1 && semester && examIdentifier) {
      try {
        const resGrp1 = await examType1Services.getQuizResultsByGroup(grpLvl1, semester, examIdentifier);
        if (resGrp1 && resGrp1.listIdUsers && resGrp1.listIdUsers.length > 0) {
          setGroup(resGrp1);
          resGrp1.elearning.elearningOptions.forEach((option) => {
            if (option.activityId === examIdentifier) {
              setExam(option);
            }
          });
          resGrp1.listIdUsers.forEach((student) => {
            if (parseFloat(student.semester, 10) === parseFloat(semester, 10)
              || parseFloat(student.semester, 10) - 1 === parseFloat(semester, 10)
              || (student.catchUp && student.catchUp?.includes(parseFloat(semester, 10)))) {
              if (student.grade) {
                papers += 1;
                const resultsNote = Number((student.grade.scoreKN || 0) + (student.grade.scoreRC || 0));
                const resultsState = resultsNote >= student.grade.total / 2 ? 'Réussi' : 'Échoué';
                formatedArray.push({
                  testId: student.testId,
                  userId: student._id,
                  note: resultsNote,
                  total: student.grade.total,
                  state: resultsState,
                  firstname: student.firstname,
                  name: student.name,
                  groupId: resGrp1._id,
                  fetched: 'No problem',
                });
              } else {
                formatedArray.push({
                  userId: student._id,
                  note: 0,
                  total: examIdentifier === '6818b5f7e1af81f95768bbc5'
                    ? 60
                    : examIdentifier === '62d509e1c5943a200c119a04'
                      ? 40
                      : 100,
                  state: 'Échoué',
                  firstname: student.firstname,
                  name: student.name,
                  groupId: resGrp1._id,
                  fetched: 'No score',
                });
              }
            }
          });
        }
      } catch (e) {
        console.error(e);
      }
    }
    if (grpLvl2 && semester && examIdentifier) {
      try {
        const resGrp2 = await examType1Services.getQuizResultsByGroup(grpLvl2, semester, examIdentifier);
        if (resGrp2 && resGrp2.listIdUsers && resGrp2.listIdUsers.length > 0) {
          resGrp2.listIdUsers.forEach((student) => {
            if (parseFloat(student.semester, 10) === parseFloat(semester, 10)
              || parseFloat(student.semester, 10) - 1 === parseFloat(semester, 10)
              || (student.catchUp && student.catchUp?.includes(parseFloat(semester, 10)))) {
              if (student.grade) {
                papers += 1;
                const resultsNote = Number((student.grade.scoreKN || 0) + (student.grade.scoreRC || 0));
                const resultsState = resultsNote >= student.grade.total / 2 ? 'Réussi' : 'Échoué';
                formatedArray.push({
                  testId: student.testId,
                  userId: student._id,
                  note: resultsNote,
                  total: student.grade.total,
                  state: resultsState,
                  firstname: student.firstname,
                  name: student.name,
                  groupId: resGrp2._id,
                  fetched: 'No problem',
                });
              } else {
                formatedArray.push({
                  userId: student._id,
                  note: 0,
                  total: examIdentifier === '6818b5f7e1af81f95768bbc5'
                    ? 60
                    : examIdentifier === '62d509e1c5943a200c119a04'
                      ? 40
                      : 100,
                  state: 'Échoué',
                  firstname: student.firstname,
                  name: student.name,
                  groupId: resGrp2._id,
                  fetched: 'No score',
                });
              }
            }
          });
        }
      } catch (e) {
        console.error(e);
      }
    }
    setTotalPapers(papers);
    setExamData(formatedArray);
    setLoadingState(false);
  };

  useEffect(() => {
    loadExamResults();
  }, [semester, examIdentifier, grpLvl1, grpLvl2]);

  const handleRedirect = () => {
    setRedirect(true);
  };

  if (redirect) {
    return <Redirect to="/list" />;
  }
  return (
    <div className={classes.root}>
      <Container className="dashboard">
        <Row>
          <Col md={1} style={{ marginBottom: '20px' }}>
            <IconButton
              aria-label="delete"
              onClick={() => handleRedirect()}
            >
              <ArrowBackIcon />
            </IconButton>
          </Col>
        </Row>
      </Container>
      <Grid container spacing={2}>
        {(examData && examData.length > 0) && <DownloadQuizCorrection examData={examData} />}
        {(examData && examData.length > 0) && <DownloadQuizsDetails examData={examData} />}
        <Grid item xs={12} style={{ width: '100%', display: 'flex', justifyContent: 'center' }}>
          {
            examData && examData.length > 0
              ? (
                <MaterialTable
                  style={{ width: '100%' }}
                  title={`Results for ${group.name.replace(/\b(level 1|level 2)\b\s*$/i, '')} - Total papers: ${totalPapers}`}
                  columns={columns}
                  isLoading={loadingState}
                  components={{
                    OverlayLoading: () => (<Loading />),
                  }}
                  localization={{
                    body: {
                      emptyDataSourceMessage: loadingState ? '' : 'No records to display',
                    },
                  }}
                  tableRef={refTable}
                  data={examData}
                  options={{
                    search: true,
                    exportButton: {
                      csv: true,
                      pdf: false,
                    },
                    exportCsv: () => {
                      const examObj = { ...exam };
                      const finalResults = [];
                      const resultsArr = [...examData];
                      resultsArr.sort((a, b) => a.name > b.name);
                      resultsArr.forEach((elem) => {
                        const item = { ...elem };
                        item.Nom = item.name;
                        item['Prénom'] = item.firstname;
                        item[examIdentifier === '6818b5f7e1af81f95768bbc5'
                          ? 'Score (/60)'
                          : examIdentifier === '62d509e1c5943a200c119a04'
                            ? 'Score (/40)'
                            : 'Score (/100)'] = item.note;
                        item['Note (/20)'] = examIdentifier === '6818b5f7e1af81f95768bbc5'
                          ? (item.note / 60) * 20
                          : examIdentifier === '62d509e1c5943a200c119a04'
                            ? (item.note / 40) * 20
                            : (item.note / 100) * 20;

                        delete item.tableData;
                        delete item.comment;
                        delete item.grade;
                        delete item.name;
                        delete item.firstname;
                        delete item.userId;
                        delete item.file;
                        delete item.created_at;
                        delete item.groupId;
                        delete item.answer;
                        delete item.fetched;
                        delete item.state;
                        delete item.testId;
                        delete item.total;
                        delete item.groupId;
                        delete item.note;
                        delete item.number;
                        finalResults.push(item);
                      });
                      const today = new Date();
                      const sortedArr = finalResults.sort((a, b) => ((
                        a.Nom > b.Nom)
                        ? 1
                        : ((b.Nom > a.Nom)
                          ? -1
                          : 0)
                      ));
                      exportXlsx(sortedArr, `${group.name.replace(/\b(level 1|level 2)\b\s*$/i, '')}_${today.getDate()}/${today.getMonth() + 1}`);
                    },
                    exportAllData: true,
                    pageSize: examData.length,
                    sorting: true,
                    tableLayout: 'auto',
                  }}
                  onRowClick={(e, data) => {
                    if (substring !== data.userId) {
                      setSubstring(data.userId);
                    } else {
                      setSubstring(null);
                    }
                  }}
                />
              )
              : <Loader type="TailSpin" color="#3F51B5" height={40} width={40} />
          }
          {examId && examId !== null
            && <ExamResultsDetails examId={examId} setExamId={setExamId} open={open} setOpen={setOpen} />}
        </Grid>
      </Grid>
    </div>
  );
};

export default ExamResultsType1;
